import { useEffect, useState } from "react";
import {
  getFbTokensApi,
  createFbTokenApi,
  updateFbTokenApi,
  deleteFbTokenApi,
  refreshTokenApi,
  refreshAllTokensApi,
  debugTokenApi,
  autoConnectFbApi,
  getOAuthUrlApi,
  handleOAuthCallbackApi,
} from "../apiServices/fbTokenServices";

const useFbTokens = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  const fetchTokens = async () => {
    try {
      setLoading(true);
      const res = await getFbTokensApi();
      setTokens(res?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createToken = async (payload) => {
    await createFbTokenApi(payload);
    fetchTokens();
  };

  const updateToken = async (id, payload) => {
    await updateFbTokenApi(id, payload);
    fetchTokens();
  };

  const deleteToken = async (id) => {
    await deleteFbTokenApi(id);
    fetchTokens();
  };

  const autoConnect = async (accessToken) => {
    try {
      setLoading(true);
      const res = await autoConnectFbApi(accessToken);
      await fetchTokens();
      return res;
    } finally {
      setLoading(false);
    }
  };

  const refreshToken = async (id) => {
    try {
      setRefreshing(true);
      const res = await refreshTokenApi(id);
      await fetchTokens();
      return res;
    } catch (error) {
      console.error("Token Refresh Failed:", error);
      throw error;
    } finally {
      setRefreshing(false);
    }
  };

  const refreshAllTokens = async () => {
    try {
      setRefreshing(true);
      const res = await refreshAllTokensApi();
      await fetchTokens();
      return res;
    } catch (error) {
      console.error("Refresh All Tokens Failed:", error);
      throw error;
    } finally {
      setRefreshing(false);
    }
  };

  const debugToken = async (id) => {
    return await debugTokenApi(id);
  };

  const getOAuthUrl = async (params) => {
    return await getOAuthUrlApi(params);
  };

  const handleOAuthCallback = async (code, redirectUri) => {
    try {
      setLoading(true);
      const res = await handleOAuthCallbackApi(code, redirectUri);
      await fetchTokens();
      return res;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  return {
    tokens,
    loading,
    refreshing,
    fetchTokens,
    createToken,
    updateToken,
    deleteToken,
    autoConnect,
    refreshToken,
    refreshAllTokens,
    debugToken,
    getOAuthUrl,
    handleOAuthCallback,
  };
};

export default useFbTokens;
